import { createRemoteComponent } from '@remote-ui/core';

/**
 * Spinner is used to notify buyers that their action is being processed.
 * The Spinner is usually used when sending or receiving data from a server.
 */
const Spinner = createRemoteComponent('Spinner');

export { Spinner };
